module.exports = __webpack_public_path__ + "img/about-fair-002@2x.beb3ddf3.jpg";